
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.init()
      }
    })
  },
  methods: {
    init() {
      this.$gsap.set(this.$refs.imageCollage, { opacity: 0 })

      const tl = this.$gsap.timeline({ delay: 0.5 })

      tl.from(this.$refs.header, {
        opacity: 0,
        xPercent: -5,
        duration: 0.5,
      })
        .from(
          '#wobble',
          {
            xPercent: 100,
            yPercent: 100,
            ease: 'power2.out',
            duration: 1,
          },
          '<'
        )
        .from(
          '#wobble2',
          {
            xPercent: -100,
            yPercent: -100,
            ease: 'power2.out',
            duration: 2,
          },
          '<'
        )
        .from(
          '#paint0_linear_5345_39001 stop',
          {
            duration: 0.5,
            attr: { offset: '0' },

            ease: 'none',
          },
          '<=+.5'
        )
        .to(
          this.$refs.imageCollage,
          {
            opacity: 1,
            duration: 1,
          },
          '<'
        )
    },
  },
}
